export default "/images/vendor/flag-icon-css/flags/4x3/bb.svg?1a39713c7071f91c422b239703b9abbf";